var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewcsDashboardLeftTutorialIconNormal = function SvgNewcsDashboardLeftTutorialIconNormal(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "newcs_dashboard_left_tutorial_icon_normal_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#707070",
    d: "M478 109h20v20h-20z",
    "data-name": "\\u77E9\\u5F62 335"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#newcs_dashboard_left_tutorial_icon_normal_svg__a)",
    transform: "translate(-478 -109)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "CurrentColor",
    d: "M478 119a10 10 0 0 1 10-10 10 10 0 0 1 10 10 10 10 0 0 1-10 10 10 10 0 0 1-10-10m1.5 0a8.51 8.51 0 0 0 8.5 8.5 8.51 8.51 0 0 0 8.5-8.5 8.51 8.51 0 0 0-8.5-8.5 8.51 8.51 0 0 0-8.5 8.5m6.892 1.607-3.215-6.43 6.43 3.215 3.215 6.43Zm.734-.7 1.763-1.793-4.23-2.429Z",
    "data-name": "\\u8054\\u5408 23"
  }))));
};
export default SvgNewcsDashboardLeftTutorialIconNormal;